module.exports = __webpack_public_path__ + "img/sala-do-empreendedor-ba.69468070.png";